import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { Observable } from "rxjs/Observable";
import * as fromRootStore from "../../../reducers";
import {
  ComboService,
  CommonService,
  SampleService,
} from "../../../services/index";
import * as fromCommonStore from "../../../store";
import * as commonActions from "../../../store/actions/common.actions";
import { SamplePrint } from "../sample/samplePrint";

@Component({
  selector: "cancelReport",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./sampleCancelReport.html",
})
export class SampleCancelReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  invoiceData: any[];
  matchList: any;
  data: any;
  sampleList: any;
  shadelist = [];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  gridOptions: any;
  partyCtrl: FormControl = new FormControl();
  partyList$ = [];
  styleData: any;
  partyList: Observable<any[]>;
  fabricList: any[];

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "sd.samp_id",
    orderDir: "desc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("stickerTemplate") stickerTemplate: TemplateRef<any>;

  columns = [];
  toggleCol = [];
  typeList = ["SWATCH", "SAMPLE", "SWATCH & SAMPLE"];
  styleList = ["FORMAL", "CASUAL", "STYLISH", "CLUB WEAR"];
  typesList = ["CANCEL", "RETURN", "ALL"];
  filterExpand = false;
  filterData: any = {
    sample_no: "",
    fab_design_no: "",
  };
  sampledata = {
    sample_no: "",
    fab_design_no: "",
    tot_colors: "",
    brand: "",
    style: "",
    dc_no: "",
    season: "",
    mtrs: 0,
    type: "",
  };
  filter = {
    sample_no: "",
    fab_design_no: "",
    tot_colors: "",
    brand: "",
    style: "",
    dc_no: "",
    season: "",
    selectedValue: "",
  };
  partyStoreSub;
  itemStoreSub;
  invoiceStoreSub;
  seasonList = [];
  printConfig: any = {
    title: "Sales Invoice",
    columns: [],
    rows: [],
  };
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private sampService: SampleService,
    public datePipe: DatePipe,
    private modalService: BsModalService,
    public toasterService: ToasterService,
    private commonService: CommonService,
    private comboservice: ComboService
  ) {
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;
           */
    this.invoiceStoreSub = this.store
      .select(fromRootStore.getLoadInvoice)
      .subscribe((isLoad: any) => {
        if (isLoad) {
          this.cancelSampleList();
        }
      });

    this.partyStoreSub = this.store
      .select(fromCommonStore.getAllParty)
      .subscribe((res: any) => {
        if (_.isEmpty(res)) {
          return;
        }
        this.partyList$ = res.data;
      });
    this.filter.selectedValue = this.typesList[2];

    /*  this.partyList = this.partyCtrl.valueChanges
              .startWith(null)
              .map(name => name ? this.filterItems(name, 'Party') : this.partyList$.slice());*/
  }

  ngOnInit(): void {
    $("#entry_div").hide();
    this.columns = [
      //{ width: 30, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: true, checkboxable :true},
      {
        name: "SNo",
        prop: "sno",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
        height: 20,
        cellClass: "text-center",
        sortable: false,
        headerClass: "text-center",
        cellTemplate: this.snoTemplate,
        toggle: true,
        isPrint: false,
      },
      {
        name: "Season",
        prop: "season",
        minWidth: 200,
        maxWidth: 200,
        width: 200,
        height: 20,
        cellClass: "text-center",
        sortable: false,
        headerClass: "text-center",
      },
      {
        name: "Samp.no",
        prop: "sample_no",
        height: 20,
        minWidth: 75,
        maxWidth: 75,
        width: 75,
        headerClass: "text-center",
        cellClass: "text-center",
        align: "right",
        type: "number",
      },
      {
        name: "Fabric Design",
        prop: "fab_design_no",
        height: 20,
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
        cellClass: "text-center",
        sortable: false,
      },
      {
        name: "Tot.Clr",
        prop: "tot_colors",
        height: 20,
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        headerClass: "text-center",
        sortable: false,
      },
      // { name: 'Brand', prop: 'brand', minWidth: 100, maxWidth: 100, width: 100, cellClass: "text-center", align: 'right', headerClass: 'text-center', type: 'text' },
      // { name: 'Style', prop: 'style', height: 20, minWidth: 100, maxWidth: 100, width: 100, headerClass: 'text-center', sortable: false },
      {
        name: "DC No",
        prop: "dc_no",
        height: 20,
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        headerClass: "text-center",
        sortable: false,
      },
      {
        name: "Mtrs",
        prop: "mtrs",
        height: 20,
        minWidth: 50,
        maxWidth: 50,
        width: 50,
        headerClass: "text-center",
        sortable: false,
      },
      {
        name: "Type",
        prop: "type",
        height: 20,
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        headerClass: "text-center",
        sortable: false,
      },
      {
        name: "Canceled By",
        prop: "canceled_by",
        height: 20,
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        headerClass: "text-center",
        sortable: false,
      },
    ];

    this.toggleCol = Object.assign({}, this.columns);
    this.data = this.commonService.itemMaster();
    //   this.getFabDesigns();
    this.getSeasonList();
    this.pageCallback({ offset: 0 });
    //   this.sampledata.season = this.invoiceData[0].season;
  }

  getFabDesigns() {
    let params;
    let that = this;
    this.sampService.getFabDesigns(params).then(function (res: any) {
      that.fabricList = res.data;
      that.sampledata.season = res.lastSeason.season;
    });
  }
  getLastSeason() {
    let params;
    let that = this;
    this.sampService.getLastSeason(params).then(function (res: any) {
      that.sampledata.season = res.data;
    });
  }
  hotkeys(event) {
    if (this.active) {
      if (event.altKey && event.keyCode === 65) {
        //          this.addEditInvoice('Add', '');
      }
      if (event.keyCode === 27) {
        //  this.bsModalRef.hide();
      }
    }
  }
  onChangePageSize(limit) {
    this.page.limit = limit;
    this.cancelSampleList();
  }
  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSeason(params).then((res: any) => {
      let partialSeason = [];
      for (let i = res.length - 1; i > res.length - 5; i--) {
        partialSeason.push(res[i]);
      }

      this.seasonList = partialSeason;
    });
  }
  showFilter() {
    $("#entry_div").hide(1000);
    $("#filter_div").show(1000);
  }
  onEnterKeyPressed(nextEl: string) {
    setTimeout(() => {
      $("#" + nextEl).focus();
    }, 100);
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.cancelSampleList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.cancelSampleList();
  }

  cancelSampleList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllInvoice(params));
    this.isLoadMask = this.sampService
      .cancelSampleList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.invoiceData = res.data;
      });
  }

  clearFilter(): void {
    this.filter = {
      sample_no: "",
      fab_design_no: "",
      tot_colors: "",
      brand: "",
      style: "",
      dc_no: "",
      season: "",
      selectedValue: "",
    };
    this.applyFilter();
  }
  clear() {
    this.sampledata = {
      sample_no: "",
      fab_design_no: "",
      tot_colors: "",
      brand: "",
      style: "",
      dc_no: "",
      mtrs: 0,
      type: "",
      season: this.sampledata.season,
    };
  }
  applyFilter(): void {
    this.cancelSampleList();
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Party") {
      list = this.partyList$;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_id: id });
      return fitem["party_name"];
    }
    return "";
  }

  @ViewChild("printPage") printPage;
  onPrintInvoice(row) {
    this.printConfig = {
      type: "invoice",
      title: "Sales Invoice",
      rows: row,
    };

    setTimeout(() => {
      this.printPage.printPreview();
    }, 100);
  }

  getStyleDetails(row) {
    let params = {
      style_no: row.style_no,
    };
    this.sampService.getStyleDetails(params).then((res: any) => {
      this.styleData = res.data;
      this.printSample("Print", row);
      //  this.loadeditsamplelist(row);
    });
  }

  bsModalRef: BsModalRef;
  printSample(mode: string, row: any): void {
    let that = this;
    setTimeout(function () {
      that.filterPanel.close();
    }, 10);

    this.bsModalRef = this.modalService.show(SamplePrint, {
      keyboard: false,
      ignoreBackdropClick: true,
      class: "modal-lg compWidth-96",
    });
    this.bsModalRef.content.title = mode + this.title + "Details";
    this.bsModalRef.content.mode = mode;
    this.bsModalRef.content.sampledata = Object.assign({}, row);
    this.bsModalRef.content.styledata = Object.assign({}, this.styleData);
    // this.bsModalRef.content.matchlist = this.matchList;
    (this.bsModalRef.content.tabID = this.tabID),
      (this.bsModalRef.content.tabTitle = this.title),
      this.bsModalRef.content.partyUpdateEvent.subscribe(($e) => {
        if (this.title == "DesignStockComponent")
          this.store.dispatch(new commonActions.LoadAllParty());
        else this.store.dispatch(new commonActions.LoadAllCompany());
      });
  }

  loadeditsamplelist(row) {
    let params = {
      samp_id: row.samp_id,
    };
    this.sampService.getEditSampleList(params).then((res: any) => {
      this.shadeList(row);

      this.sampleList = res.data;
    });
  }
  shadeList(row) {
    // let coloList = row.sample_color;
    let sample_no = row.sample_no;
    let params = {
      sample_no: sample_no,
    };

    this.sampService.getShadeList(params).then((res: any) => {
      let data1: any = res.data;

      for (var i = 0; i < data1.length; i++) {
        for (var key in data1[i]) {
          let temp = data1[i][key];
          this.shadelist.push(temp);
        }
      }
      this.clickPrint(row, this.shadelist);
      console.log(res);
    });
  }
  clickPrint(row, data) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);
    that.isLoadMask = that.sampService
      .sampleSticker(params)
      .then(function (res: any) {});
  }

  ngOnDestroy() {
    this.partyStoreSub.unsubscribe();
    this.invoiceStoreSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sampleReport/sampleCancelReport.ts